import { JsonObject } from "./customizationUtils";

export type TemplateAssignment = {
  role_name: string;
  is_default: boolean;
};

export type ReviewTemplate = {
  template_id: string;
  name: string;
  category: string;
  config_json: JsonObject;
  is_locked: boolean;
  updated_at: string;
  assignments?: TemplateAssignment[];
};

export type TemplateDraft = {
  name: string;
  configText: string;
  isLocked: boolean;
};

export type BadChannelMark = {
  id: string;
  channel_name: string;
  reason_code: string;
  note: string | null;
  marked_at: string;
};

export type RereferencePreview = {
  excluded_channels: string[];
  auto_excluded: string[];
  manually_excluded: string[];
  note: string;
};

export type FilterOverride = {
  id: string;
  channel_name: string;
  hp: number | null;
  lp: number | null;
  notch: number | null;
  updated_at: string;
};

export type ReportSnapshot = {
  snapshot_id: string;
  timestamp_in_recording: number;
  caption: string | null;
  display_order: number;
  montage_id: string | null;
};

export type SnapshotDraft = {
  caption: string;
  displayOrder: number;
};

export type ReportPackageResponse = {
  package: {
    report_id: string;
    snapshot_count: number;
    generated_at: string;
  };
  pdf_status: string;
  message: string;
};

export type DualMontagePreference = {
  left_montage_id: string | null;
  right_montage_id: string | null;
  sync_cursor: boolean;
  sync_zoom: boolean;
  sync_playback: boolean;
  diff_highlight: boolean;
};

export type AnnotationMacro = {
  macro_id: string;
  name: string;
  hotkey: string;
  phrase_id: string;
};

export type AnnotationPhrase = {
  phrase_id: string;
  label: string;
  phrase_text: string;
  metadata_json: JsonObject;
  display_order: number;
  version: number;
};

export type AnnotationDictionary = {
  dict_id: string;
  name: string;
  category: string | null;
  version: number;
  phrases: AnnotationPhrase[];
  macros: AnnotationMacro[];
};

export type TrendProfile = {
  id: string;
  name: string;
  thresholds_json: JsonObject;
  updated_at: string;
};

export type TrendThresholds = {
  dsa_low: number;
  dsa_high: number;
  csa_threshold: number;
  asymmetry_pct: number;
  lookback_seconds: number;
  lookahead_seconds: number;
  evaluation_interval_seconds: number;
};

export type TrendPreviewResponse = {
  profile_name: string;
  alert_count: number;
  alerts: Array<{ metric: string; expected: string; actual: unknown }>;
};

export type EvidenceSnapshot = {
  id: string;
  generated_at: string;
  label: string | null;
  snapshot_json: { kpis?: JsonObject };
  provenance?: {
    source_recording_id?: string | null;
    source_study_id?: string | null;
    linked_segments?: string | null;
    raw_eeg_confirmed?: boolean;
    validation_cohort?: string | null;
    dataset_version?: string | null;
    validation_method?: string | null;
    approval_status?: string;
  };
};

export const TEMPLATE_CATEGORIES = ["icu", "emu", "peds", "sleep", "custom"];
export const BAD_CHANNEL_REASON_CODES = [
  "high_impedance",
  "artifact_persistent",
  "electrode_off",
  "manual_override",
];
